import React, {useS, useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { useSelector} from 'react-redux'
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import IconNav from './components/iconNav'
import Header from './components/header'
import Initial from './components/initial'
import './App.css';
import Footer from './components/footer';
import Flights from './components/flights';
import Driving from './components/driving'
import Lodging from './components/lodging'

import { createHashHistory } from "history";
import Review from './components/review';
import Total from './components/total';
import CalculatorContext from './Context'
import API from './api/api';
import Button from './components/button';

const browserHistory = createHashHistory();

function App() {  
  const [selectedFlight, setSelectedFlight] = useState(0)
  const [selectedDriving, setSelectedDriving] = useState(0)
  const [carbon, setCarbon] = useState(0)  
  const [price, setPrice] = useState(1)
  const [airMiles, setAirMiles] = useState(0)
  const [carMiles, setCarMiles] = useState(109.4)
  const [lodging, setLodging] = useState(0.038)  
  const [amount, setAmount] = useState(0)
  const [percent, setPercent] = useState(100)
  const [loaded, setLoaded] = useState(false)
  const [smartphone, setSmartphone] = useState(8927)
  const [coal, setCoal] = useState(77)
  const [lodgingItineraries, setLodgingItineraries] = useState([{nights:1, rooms:1}])
  const [flightItineraries, setFlightItineraries] = useState([{
    fromValue: null,
    toValue: window.calculator_options.airport,
    passengers: 1,
    flightType: 0,
    viaValue: null
  }])
  const [drivingItineraries, setDrivingItineraries] = useState([
    window.calculator_options.is_big_sky?(
    {
    fromDriving: {name:"BZN airport",id:"BZN airport, Gallatin Field Road, Belgrade, MT, USA"},
    toDriving: {name:"Big Sky Resort", id:"50 Big Sky Resort Rd, Big Sky, MT, USA"},
    distance: 103.24,
    invalid: 1,
    driveType: 0
  }):({
    fromDriving: {name:"", id:""},
    toDriving: {name:"", id:""},
    distance: 0,
    invalid: 1,
    driveType: 0
  })])
  const contextState = {
    airMiles,
    setAirMiles,
    carbon,
    price,
    amount,
    carMiles,
    percent, 
    setPercent,
    setAmount,
    setLodging,
    lodgingItineraries,
    setLodgingItineraries,
    flightItineraries,
    setFlightItineraries,
    drivingItineraries,
    setDrivingItineraries,
    setCarMiles,
    smartphone,
    coal,
    selectedFlight,
    setSelectedFlight,
    selectedDriving,
    setSelectedDriving,
  }
  useEffect(()=>{
    if (!loaded){
      API.getDefault()
      .then((defaultValues)=>{
        const {air_miles, car_miles, lodging, total, price, smartphones, coal} = defaultValues.data
        setCarMiles(car_miles)
        setLodging(lodging)
        setAirMiles(air_miles)
        setCarbon(total)      
        setPrice(price)
        setAmount(Number(total*price).toFixed(2))
        setLoaded(true)
        setSmartphone(smartphones)
        setCoal(coal)
      })
    }else{
      API.calculate({air_miles:airMiles, car_miles:carMiles, lodging})
      .then((defaultValues)=>{
        const {total, price, coal, smartphones} = defaultValues.data
        setCarbon(total)      
        setPrice(price)
        setAmount(Number(total*price).toFixed(2))
        setSmartphone(smartphones)
        setCoal(coal)
      })
    }
  },[airMiles, carMiles, lodging, loaded])

  return (
    <div className="App widget">  
      <div className="logo">
        <img src="/wp-content/themes/tradewater/dist/widget/images/logo.svg" alt="logo"/>
      </div>                      
      <div className="line main-line" />
      <CalculatorContext.Provider value={contextState}>
        <Router history={browserHistory}>
          <Route exact path="/">
            <Header>
              Carbon Calculator
            </Header>
          </Route>
          <IconNav />
          <Switch>
            <Route exact path="/">
              <Initial />
            </Route>
            <Route  path="/flights">
              <div className="total-container">
                <Flights />
                <Total />
              </div>
            </Route>
            <Route  path="/driving">
              <div className="total-container">
                <Driving />
                <Total />
              </div>
            </Route>     
            <Route  path="/lodging">
              <div className="total-container">
                <Lodging />
                <Total />
              </div>
            </Route>  
            <Route  path="/review">
              <div className="total-container">              
                <div className="total-container-button">
                  <Total />
                  <div className="final-btn">
                    <Button showImage={false} className="primary back" onClick={()=>browserHistory.push('/lodging') }>
                      BACK
                    </Button> 
                  </div>
                </div>
                <Review value={amount} onChange={(value)=>setAmount(value)}/>
              </div>
            </Route>                
          </Switch>
        </Router>
      </CalculatorContext.Provider>
      <Footer />
    </div>
  );
}

export default App;
